AgrimarketControllers.controller('userSmsAlertController', [
    '$scope', '$rootScope',  '$location', 'colonnes', 'smsAlertService', 'offerService',
    function ($scope, $rootScope,  $location, colonnes, smsAlertService, offerService) {

        //appel iframe

    }
]);